class ContactFormModal extends HTMLElement {
    constructor() {
      super();
      this.dialog = this.querySelector('[data-modal-dialog]');
      this.closeButtons = this.querySelectorAll('[data-modal-close], [data-modal-overlay]');
      this.boundOpenHandler = this.handleOpenTrigger.bind(this);
      this.boundCloseHandler = this.close.bind(this);
      this.boundEscHandler = this.handleEsc.bind(this);
    }
  
    connectedCallback() {
      document.addEventListener('click', this.boundOpenHandler);
  
      this.closeButtons.forEach((button) => {
        button.addEventListener('click', this.boundCloseHandler);
      });
  
      const sectionId = this.dataset.sectionId;
      if (
        window.contactModalOpenOnLoad &&
        sectionId &&
        window.contactModalOpenOnLoad[sectionId] === true
      ) {
        this.open();
      }
    }
  
    disconnectedCallback() {
      document.removeEventListener('click', this.boundOpenHandler);
  
      this.closeButtons.forEach((button) => {
        button.removeEventListener('click', this.boundCloseHandler);
      });
  
      document.removeEventListener('keydown', this.boundEscHandler);
    }
  
    handleOpenTrigger(event) {
      const trigger = event.target.closest(
        'a[href="#open-contact-form"], button[data-open-contact-form]'
      );
  
      if (!trigger) return;
  
      event.preventDefault();
      this.open();
    }
  
    open() {
      this.classList.add('is-open');
      document.documentElement.classList.add('overflow-hidden');
      document.body.classList.add('overflow-hidden');
      document.addEventListener('keydown', this.boundEscHandler);
  
      if (this.dialog) {
        this.dialog.focus();
      }
    }
  
    close(event) {
      if (event) event.preventDefault();
  
      this.classList.remove('is-open');
      document.documentElement.classList.remove('overflow-hidden');
      document.body.classList.remove('overflow-hidden');
      document.removeEventListener('keydown', this.boundEscHandler);
    }
  
    handleEsc(event) {
      if (event.key === 'Escape') {
        this.close();
      }
    }
  }
  
  if (!customElements.get('contact-form-modal')) {
    customElements.define('contact-form-modal', ContactFormModal);
  }